import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, ArrowUpRight } from "lucide-react";
import { COMPANY } from "@/lib/content";

export default function Footer() {
  return (
    <footer className="relative bg-wcc-navy text-white overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src="/assets/logo.png" alt="West Coral" className="h-14 w-auto bg-white rounded-sm p-1.5" />
            </div>
            <p className="text-white/60 max-w-md leading-relaxed">
              Underground telecommunications infrastructure contractor specializing in turnkey underground
              fiber construction, FTTH, and utility installation across the Southeast.
            </p>
            <div className="mt-8 space-y-3">
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(COMPANY.address)}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="footer-address"
              >
                <MapPin className="w-5 h-5 text-wcc-red shrink-0 mt-0.5" />
                {COMPANY.address}
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-wcc-red shrink-0" />
                {COMPANY.email}
              </a>
            </div>
          </div>

          <div>
            <h4 className="mono text-[11px] uppercase tracking-[0.25em] text-wcc-red mb-5">Explore</h4>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/" className="hover:text-white transition-colors">Capabilities</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/resources" className="hover:text-white transition-colors">Contractor Resources</Link></li>
              <li><Link to="/onboarding" className="hover:text-white transition-colors">Employee Portal</Link></li>
              <li><Link to="/portal/login" className="hover:text-white transition-colors">Owner Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mono text-[11px] uppercase tracking-[0.25em] text-wcc-red mb-5">Recruiting</h4>
            <p className="text-white/70 leading-relaxed">
              {COMPANY.recruitingContact.name}
              <br />
              <a href={`mailto:${COMPANY.recruitingContact.email}`} className="hover:text-white transition-colors underline underline-offset-4 decoration-white/20">
                {COMPANY.recruitingContact.email}
              </a>
            </p>
            <Link
              to="/careers"
              className="mt-6 inline-flex items-center gap-1.5 bg-white text-wcc-navy font-semibold px-5 py-2.5 rounded-sm hover:bg-wcc-red hover:text-white transition-colors"
              data-testid="footer-apply-cta"
            >
              Apply Now <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="mono text-[11px] uppercase tracking-widest text-white/40">
            © {new Date().getFullYear()} {COMPANY.legal} · Equal Opportunity Employer
          </p>
          <p className="mono text-[11px] uppercase tracking-widest text-white/40">
            Fully Insured · OSHA Compliant · Drug-Free Workplace
          </p>
        </div>
      </div>

      <div className="select-none pointer-events-none -mb-4 sm:-mb-8">
        <p className="font-display font-semibold text-center leading-none text-outline-white text-[16vw]">
          WEST CORAL
        </p>
      </div>
    </footer>
  );
}
